'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosEyeOutline = function IoIosEyeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.9 20l0.1 0.1-0.5 0.4c-1.6 1.7-3.6 3.8-6.1 5.4-2.8 1.9-5.6 2.9-8.4 2.9-6.5 0-10.2-3.9-14.5-8.3l-0.5-0.5 0.1-0.1c3-3.1 5.2-5 7.3-6.3 2.5-1.6 4.9-2.3 7.6-2.3 6.5 0 11.4 4.6 14.9 8.7z m-14.9-7.5c-4.8 0-8.7 2.8-13.3 7.5 1.9 1.9 3.8 3.9 6 5.3 2.3 1.6 4.6 2.2 7.3 2.2 5.9 0 10.4-4.4 13.4-7.4-2.1-2.3-3.9-3.9-5.8-5.2-2.5-1.6-5-2.4-7.6-2.4z m0 13.8c-3.4 0-6.2-2.9-6.2-6.3s2.8-6.2 6.2-6.2 6.3 2.8 6.3 6.2-2.9 6.3-6.3 6.3z m0-11.3c-2.7 0-5 2.3-5 5s2.3 5 5 5 5-2.3 5-5-2.3-5-5-5z m2.5 5h1.3c0 2-1.8 3.8-3.8 3.8s-3.7-1.7-3.7-3.8 1.7-3.7 3.7-3.7v1.2c-1.2 0-2.5 1-2.5 2.4s1.2 2.6 2.5 2.6 2.5-1.1 2.5-2.5z' })
        )
    );
};

exports.default = IoIosEyeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-eye-outline.js
// module id = 2630
// module chunks = 168707334958949